import { ReactElement } from 'react'

import FindDetalhesViagemComVPOImpl from 'modules/valePedagio/domain/usecases/FindDetalhesViagemComVPO'
import ValePedagioRepository from 'modules/valePedagio/infra/repositories/ValePedagioRepository'
import DetalhesViagem from 'modules/valePedagio/pages/DetalhesViagem'

export const DetalhesViagemFactory = (): ReactElement => {
  const repository = new ValePedagioRepository()
  const usecase = new FindDetalhesViagemComVPOImpl(repository)

  return <DetalhesViagem findDetalhesViagemComVPO={usecase} />
}
